// 外部接続先が全て本番環境の場合
export const region = 'ap-northeast-1';
export const stage: 'develop' | 'staging' | 'production' = 'production';
export const bkpPath = 'https://bitlock.bitkey.cloud/v1';
export const ifBaseApiPath = 'https://api.sumamoru.entryservice.jp/link/api/v1';
export const bitlockApiPath =
  'https://us-central1-bitlock-production.cloudfunctions.net/ext-v1';
export const bitlockVoApiPath =
  'https://us-central1-bitlock-production.cloudfunctions.net/ext-vo';
export const bitlockVoApiKey = `iuefvjojhfviufaepo48575.4592347525iohgfkrr94758275907903u4175`;
export const bitlockVoVerifyIdentityApiKey = `uvsagvbg6234872355906295vhbjnfjsdchn723t5825935429dthrvbwehrvb257`;

// Datadog RUM
export const datadogEnabled = true;
export const datadogApplicationId = '7a559a38-1f2b-440b-aadc-b4b6a3df658d';
export const datadogClientToken = 'pub37db9ba78979bd919ac8adbd25c6ebfe';
export const datadogService = 'bitlock-og-entry-service';
export const datadogSite = 'datadoghq.com';

// 入居者アクティベート用。takuty 中継ではなく homehub を直接呼ぶ
export const homehubUserApiPath = 'https://api.homehub.site/homehubCoreUserApi/v1';

// v2用のAPIパス
export const v2BaseApiPath = 'https://api.sumamoru.entryservice.jp/link/api/v1/sumamoru-v2';
